import { SelectableItem } from "../../processingActivity/ProcessingActivity.types.ts";
import { FrameworkTemplateLanguage } from "../createEditTemplateDialog/CreateEditTemplateDialog.types.ts";

export interface TemplatesTableRowModel {
    id: string;
    name: string;
    description: string;
    complianceAreas: Array<SelectableItem>;
    numberOfControls: number;
    numberOfAnnualWheelActivities: number;
    isPublished: boolean;
    languages: Array<FrameworkTemplateLanguage>;
    templatePlanRequirements: Array<TemplatePlanRequirement>;
    order: number;
}

export interface TemplatesTableViewModel extends TemplatesTableRowModel {
    complianceAreasString: string;
    templatePlanRequirementsString: string;
}

export enum TemplatePlanRequirement {
    DataProtection = 1,
    InformationSecurity = 2,
    VendorManagement = 3,
    ContractManagement = 4,
    Frameworks = 5,
}
